import { getUrlFiles } from "../../../utils/services/files";

export const validateUUID = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
    value.trim()
  );

export const uploadImage = async (file, token, toast) => {
  if (!file?.type?.startsWith("image/")) return null;
  const data = new FormData();
  data.append("files", file);
  data.append("folder", "");
  try {
    const response = await getUrlFiles(data, token);
    return response[0]?.url || "";
  } catch (error) {
    console.error("Erro ao enviar imagem:", error);
    toast.error("Erro ao enviar imagem!");
    return null;
  }
};
